var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcHdFill = function SvgIcHdFill(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M1 7.455C1 4.442 3.686 2 7 2h10c3.314 0 6 2.442 6 5.455v9.09C23 19.559 20.314 22 17 22H7c-3.314 0-6-2.442-6-5.454zm12.648 8.335a.8.8 0 0 1-.8-.8V9.01a.8.8 0 0 1 .8-.8h2.095c2.27 0 3.614 1.35 3.614 3.75v.011c0 2.406-1.34 3.82-3.614 3.82zm.787-1.613a.3.3 0 0 0 .3.3h.819c1.418 0 2.185-.861 2.185-2.5v-.01c0-1.582-.793-2.449-2.185-2.449h-.82a.3.3 0 0 0-.3.3zM5 14.997a.793.793 0 1 0 1.586 0v-2.3a.1.1 0 0 1 .1-.1h3.215a.1.1 0 0 1 .1.1v2.3a.793.793 0 1 0 1.587 0V9.003a.793.793 0 0 0-1.587 0v2.185a.1.1 0 0 1-.1.1H6.686a.1.1 0 0 1-.1-.1V9.003a.793.793 0 0 0-1.586 0z",
    clipRule: "evenodd"
  })));
};
export default SvgIcHdFill;